<---三味 考研推广页面 -->
<template>
  <div class="container">
    <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/sanwei-ky/sanwei_ky_bg.jpg" alt="" class="img" />
    <div class="input-container ky">
      <div class="input-box">
        <input type="text" maxlength="15" placeholder="请输入您的手机号，仅开课使用，已加密" v-model="formData.mobile" />
      </div>
      <div class="input-box">
        <input type="text" maxlength="15" placeholder="请输入验证码" v-model="formData.msg" />
        <div class="code" @click="sendMsg">
          获取验证码<span v-if="codeTime != 60">({{ codeTime }})</span>
        </div>
      </div>
      <div class="radio-wrapper">
        <div class="radio-item" v-for="(item, index) in list" :key="index" @click="radioChange(index)">
          <img src="@/assets/imgs/check_box_selected.png" v-if="item.isSelected" />
          <img src="@/assets/imgs/check_box.png" v-else />
          <span>{{ item.name }}</span>
        </div>
      </div>
      <div class="submit" @click="onsubmit" />
    </div>
  </div>
</template>

<script>
import { enrollPwd, sendMsg } from '@/api/index'
import md5 from 'js-md5'
import { phoneValidator } from '@/utils'
export default {
  data() {
    return {
      codeTime: 60,
      formData: {
        mobile: '',
        msg: ''
      },
      list: [
        {
          name: '管理专硕',
          shortName: 'ky',
          id: 'BK202405290001',
          promotedAccount: '图书-三味-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语二+管综',
              worthid: 'dc90b91a611b4cde8f73b3a7e4a7c8bf',
              subjectid: '6c1095e7c99c4e5397a57d575a2db3e5'
            }
          ]
        },
        {
          name: '教育专硕',
          shortName: 'ky',
          id: 'BK202406180004',
          promotedAccount: '图书-三味-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语一+政治+教育综合',
              worthid: 'b97eafdd85f24d65bb27bf0d9f16b025',
              subjectid: 'b5fee91a139d41a2ae33ceddc4c24e72'
            },
            {
              name: '英语二+政治+教育综合',
              worthid: 'd9222f377ca440d09be9dd03fa5cff69',
              subjectid: '8f6f0bbf333a453889b5a19a0175614b'
            }
          ]
        },
        {
          name: '护理/护理学',
          shortName: 'ky',
          id: 'BK202406180005',
          promotedAccount: '图书-三味-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语一+政治+护理综合',
              worthid: '72ec7ea2e9244aa5a00273b0512dad55',
              subjectid: '2b7765fafbcd4879a5efe710f6ebe0bc'
            }
          ]
        },
        {
          name: '应用心理',
          shortName: 'ky',
          id: 'BK202406180008',
          promotedAccount: '图书-三味-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语一+政治+心理学综合',
              worthid: 'd20a18cf965f43e4b36dfc6239dda3a1',
              subjectid: '4eef0d0b666043989e93abc06aed1791'
            },
            {
              name: '英语二+政治+心理学综合',
              worthid: '09bb4151f49e442092c52c13f9c99dd4',
              subjectid: 'c9e4bf34acf84120992c87c73f72f79a'
            }
          ]
        },
        {
          name: '临床医学(西医)',
          shortName: 'ky',
          id: 'BK202406180006',
          promotedAccount: '图书-三味-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语（一）',
              worthid: '102b4d6eb3564eb6bfe6f34de203bdb8',
              subjectid: '059b5d68a0f64f7da7dfbc034485536c'
            },
            {
              name: '思想政治理论',
              worthid: '12f06d48e165474a8a2ff36c6d742dd4',
              subjectid: '106facca9bad454d8e44b8b772d76166'
            },
            {
              name: '临床医学综合能力(西医)',
              worthid: '354e0d7334684bbe8708d7ff974366b0',
              subjectid: '3f13dafd598947d2800124b3cf6cd796'
            }
          ]
        },
        {
          name: '法律(法学/非法学)',
          shortName: 'ky',
          id: 'BK202406180007',
          promotedAccount: '图书-三味-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语（一）',
              worthid: 'd715e3b213194851abf2f65973131ca8',
              subjectid: '059b5d68a0f64f7da7dfbc034485536c'
            },
            {
              name: '思想政治理论',
              worthid: 'b761d99bc207411b8a541a74f8b81992',
              subjectid: '106facca9bad454d8e44b8b772d76166'
            },
            {
              name: '法律（法学）专业基础+综合',
              worthid: '389607c181d64b2e8eb474a0d6faf3df',
              subjectid: 'f7b205a2ec6542948686b7720e36a6ac'
            },
            {
              name: '法律（非法学）专业基础+综合',
              worthid: '60371610fa634c99817f3a01280af950',
              subjectid: '6a289a14a645473faa9bc443aa0acbc5'
            }
          ]
        },

        {
          name: '英语',
          shortName: 'ky',
          id: 'BK202406180009',
          promotedAccount: '图书-三味-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语（一）',
              worthid: 'e6699f489d214dea93014275a40e1037',
              subjectid: '059b5d68a0f64f7da7dfbc034485536c'
            },
            {
              name: '英语（二）',
              worthid: 'c90b2a33d1cb4d42a6f0cb61dbb3457b',
              subjectid: '318bce61f95740d1aed00a31ea465d23'
            }
          ]
        },
        {
          name: '政治',
          shortName: 'ky',
          id: 'BK202406180010',
          promotedAccount: '图书-三味-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '思想政治理论',
              worthid: '1476bcffcba547509ffa69ee646e28fd',
              subjectid: '106facca9bad454d8e44b8b772d76166'
            }
          ]
        },
        {
          name: '数学',
          shortName: 'ky',
          id: 'BK202406180011',
          promotedAccount: '图书-三味-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '数学（一）',
              worthid: '74bf8b58378a423c971247d89d5b86a3',
              subjectid: '6545d2a56d594562b7db97e65b44b667'
            },
            {
              name: '数学（二）',
              worthid: 'e01e324acd2049dfae2bf48a81a226ec',
              subjectid: '6d485fc3920042eb926718f7f77f5174'
            },
            {
              name: '数学（三）',
              worthid: '52a6cfc4171a439ca526d0d5be45c2c0',
              subjectid: '70e3a9f7a5b34c7bb6d3e587597a683c'
            }
          ]
        }
      ],
      id: '',
      currentCourse: {},
      //发送验证码
      isCodeClickable: true
    }
  },
  methods: {
    radioChange(index) {
      this.list.forEach(item => (item.isSelected = false))
      const current = this.list[index]
      current.isSelected = true
      this.$set(this.list, index, current)
    },
    sendMsg() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }
      if (!this.isCodeClickable) {
        return
      }
      sendMsg({
        phone: this.formData.mobile,
        type: 1,
        corpId: '123456789'
      }).then(res => {
        this.isCodeClickable = false
        this.setCodeTime()
      })
    },
    setCodeTime() {
      const copy = this.codeTime
      const interval = setInterval(() => {
        let codeTime = this.codeTime - 1
        if (this.codeTime === 0) {
          clearInterval(interval)
          codeTime = copy
          this.isCodeClickable = true
        }
        this.codeTime = codeTime
      }, 1000)
    },
    onsubmit() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }

      if (!this.formData.msg) {
        this.$toast.center('请输入验证码')
        return
      }

      if (!this.list.find(item => item.isSelected)) {
        this.$toast.center('请选择科目')
        return
      } else {
        this.currentCourse = this.list.find(item => item.isSelected)
      }

      const gt = new Date().getTime().toString()
      enrollPwd({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        ...this.formData,
        classid: this.currentCourse.id,
        subjectid: this.currentCourse.subjectList.map(item => item.subjectid).join(','),
        worthid: this.currentCourse.subjectList.map(item => item.worthid).join(','),
        collegeName: this.currentCourse.collegeName,
        orign: '图书',
        promotedAccount: `${this.currentCourse.promotedAccount}`
      }).then(res => {
        this.$toast.center('提交成功')
        this.formData.mobile = ''
        this.formData.msg = ''
        setTimeout(() => {
          window.location.href = 'https://www.zhongke3.com/zj-app-h5/mp_toutiao/qscode/1795719887050752000'
        }, 2000)
      })
    }
  },
  created() {}
}
</script>
<style>
body {
  min-width: 100%;
}
</style>
<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100vw;
  &::-webkit-scrollbar {
    display: none;
  }
  .img {
    position: absolute;
    width: 100vw;
    top: 0;
    vertical-align: bottom;
    z-index: 0;
  }
  .input-container {
    position: relative;
    height: 58vw;
    width: 100%;
    padding: 171vw 0 0;
    z-index: 1;

    .input-box {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      padding: 0 9.5vw;
      input {
        flex: 1;
        border: none;
        outline: none;
        padding-left: 10px;
        border: 1px solid #f1f8ff;
        border-radius: 4px;
        font-size: 12px;
        height: 41px;
        box-shadow: none;
        background: rgb(243, 244, 246);
      }
      .code {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        color: #fff;
        font-size: 12px;
        width: 99px;
        height: 43px;
        border-radius: 5px;
        background: rgb(27, 102, 203);
        span {
          color: #fff;
        }
      }
    }
    .radio-wrapper {
      display: flex;
      flex-wrap: wrap;
      padding-left: 6vw;
      padding-top: 1.5vw;

      .radio-item {
        display: flex;
        &:not(:last-child) {
          margin-right: 5px;
        }
        img {
          width: 4.5vw;
          height: 4.5vw;
          margin-right: 1px;
        }
        span {
          font-size: 12px;
          color: #666;
        }
      }
    }
    &.ky {
      padding: 160vw 0 0;
      .radio-wrapper {
        padding-left: 7vw;
        .radio-item {
          width: 29%;
          margin-bottom: 2vw;
          margin-right: 0 !important;
          &:nth-child(6) {
            width: 33%;
          }
        }
      }
    }

    .submit {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      margin: 21px auto 0;
      color: #fff;
      font-size: 14px;
      border-radius: 2px;
      height: 100%;
      width: 90%;
      background: none;
    }
  }
}
</style>
